import * as Updates from 'expo-updates';
import { type UpdateFetchResult } from 'expo-updates';

import { fromPromise } from 'xstate5';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Checks for and fetches OTA updates.
 */
export const fetchUpdateIfAvailable = fromPromise<UpdateFetchResult | undefined>(async function () {
  const checkForUpdateResult = await Updates.checkForUpdateAsync();

  if (!checkForUpdateResult.isAvailable) {
    return;
  }

  return Updates.fetchUpdateAsync();
});

/**
 * Restarts the app to apply the update.
 *
 * We use `requestIdleCallback` to ensure that the app is idle before restarting it.
 * This is to avoid the app from being restarted while it's busy with other tasks,
 * which can lead to crashes or other issues.
 */
export const restartApp = fromPromise<void>(async function () {
  return new Promise((resolve, reject) => {
    requestIdleCallback(() => {
      Updates.reloadAsync().then(resolve).catch(reject);
    });
  });
});
